module.exports = __webpack_public_path__ + "static/globe-1f79a95b37c5565b83d743c4f9efe9d3.svg";